import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, Subscription, catchError, throwError} from 'rxjs';
import {Auth, getAuth} from 'firebase/auth';
import {PersonsQuerysService} from './personsquerys.service';
import {ValidatorResponse} from '../models/validator-response.interface';
import {ViaCheckApiQueryService} from './via-check-api-query.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authSubscriptions = new Subscription();

  constructor(private http: HttpClient, private router: Router) {}

  private handleError(error: HttpErrorResponse) {
    return throwError(
      () =>
        new Error(
          `Hubo un error en el proceso de Autorización, porfavor intenta más tarde. ${error.message} ${error}`
        )
    );
  }

  // Este no puede usar el viachekapiquery service porque no hay auth en este punto!!!
  validateUserEmail(
    userID: string,
    secret: string
  ): Observable<ValidatorResponse> {
    const subdomain = 'validator';
    const body = {userID, secret};
    const header = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,HEAD,PUT,PATCH,POST,DELETE',
      'Access-Control-Allow-Headers': 'Content-Type, Accept',
    });

    return this.http
      .post<any>(`${environment.baseURL}${subdomain}`, body, {
        headers: header,
      })
      .pipe(catchError(this.handleError));
  }

  ngOnDestroy(): void {
    this.authSubscriptions.unsubscribe();
  }
}
